import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Landing } from "./screens/Landing/landing.view";
import { ErrorRoute } from "./screens/Error/error.view";
import { Login } from "./screens/Login/login.view";
import { Register } from "./screens/Register/register.view";
import { RecuperarContraseña } from "./screens/Usuario/RegistrarUsuario/RecuperarContraseña/recuperarcontraseña.view";
import { NuevaContraseña } from "./screens/Usuario/RegistrarUsuario/NuevaContraseña/nuevacontraseña.view";
import { AdminRoute } from "./routes/admin.route";
import { UserRoute } from "./routes/user.route";
import { ScrollToTop } from "./components/Generales/ScrollToTop";
import "./App.scss";
import { user_token } from "./redux/actions/userAction";
import { id_Participante } from "./redux/actions/participantesAction";
import getStorageUser from "./middlewares/GetStorageUser"
import { VerConvocatoriasTwo } from "./screens/Landing/VerConvocatorias/VerConvocatoriasTwo";
import { Lep } from "./screens/Landing/VerConvocatorias/Lep";
import { Mujeres } from "./screens/Landing/VerConvocatorias/Mujeres";
import { Pp } from "./screens/Landing/VerConvocatorias/Pp";
import { PpEstimulos } from "./screens/Landing/VerConvocatorias/Pp-estimulos";
import { PpFormacion } from "./screens/Landing/VerConvocatorias/Pp-formacion";
import { PpFortalecimiento } from "./screens/Landing/VerConvocatorias/Pp-fortalecimiento";
import { PpAgenda } from "./screens/Landing/VerConvocatorias/Pp-agenda";
import { PpCic } from "./screens/Landing/VerConvocatorias/Pp-cic";
import { Mcm } from "./screens/Landing/VerConvocatorias/Mcm";
import { Form } from "./screens/Landing/VerConvocatorias/components/Forms/form";
import { Agenda } from "./screens/Landing/VerConvocatorias/agenda";
import { Proximamente } from "./screens/Landing/VerConvocatorias/proximamente";
import { Beneficiarios } from "./screens/Landing/VerConvocatorias/Beneficiarios";
import { Mentorias } from "./screens/Landing/VerConvocatorias/Mentorias";
import { Asistencia } from "./screens/Landing/VerConvocatorias/Asistencia";
import { Miradas } from "./screens/Landing/VerConvocatorias/Miradas"
import { MiradasPrensa } from "./screens/Landing/VerConvocatorias/MiradasPrensa"
import { MiradasIndustria } from "./screens/Landing/VerConvocatorias/MiradasIndustria"
import { MiradasProgramacion } from "./screens/Landing/VerConvocatorias/MiradasProgramacion"

const App = () => {
  const dispatch = useDispatch();

  const getUser = async () => {
    try {
      const user = getStorageUser();
      // Hay casos con token en localStorage pero sin los datos del usuario. Despachar eso
      // reventaba la aplicacion en cada carga, asi que se avisa y no se continua.
      if (!user) {
        console.warn("[Sesion] Hay token pero no datos de usuario en localStorage: no se inicia sesion.");
        return;
      }
      dispatch(user_token(user));
      dispatch(id_Participante(parseInt(user?.documento)));
    } catch (error) {
      console.log(error);
    }
  }

  const clearCacheData = () => {
    if (typeof caches !== 'undefined') {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
  };

  useEffect(() => {
    (async () => {
      clearCacheData();
      const token = localStorage.getItem('token')

      if (token) {
        getUser();
      }
    })();
  }, [])


  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/login/:screen" element={<Login />} />
      <Route path="/login/:screen/:id" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/recuperar" element={<RecuperarContraseña />} />
      <Route path="/cambiarcontrasena" element={<NuevaContraseña />} />
      <Route path="/verconvocatoria/:id" element={<VerConvocatoriasTwo />} />
      <Route path="/lep" element={<Lep />} />
      <Route path="/mujeres" element={<Mujeres />} />
      <Route path="/pp" element={<Pp />} />
      <Route path="/ppestimulos" element={<PpEstimulos />} />
      <Route path="/ppformacion" element={<PpFormacion />} />
      <Route path="/ppfortalecimiento" element={<PpFortalecimiento />} />
      <Route path="/ppagenda" element={<PpAgenda />} />
      <Route path="/ppcic" element={<PpCic />} />
      <Route path="/mcm" element={<Mcm />} />
      <Route path="/administrador/*" element={<AdminRoute />} />
      <Route path="/usuario/*" element={<UserRoute />} />
      <Route path="/*" element={<ErrorRoute />} />
      <Route path="/form" element={<Form />} />
      <Route path="/agenda" element={<Agenda />} />
      <Route path="/proximamente" element={<Proximamente />} />
      <Route path="/beneficiarios" element={<Beneficiarios />} />
      <Route path="/mentorias" element={<Mentorias />} />
      <Route path="/asistencia" element={<Asistencia />} />
      <Route path="/miradas" element={<Miradas />} />
      <Route path="/miradasPrensa" element={<MiradasPrensa />} />
      <Route path="/miradasIndustria" element={<MiradasIndustria />} />
      <Route path="/miradasProgramacion" element={<MiradasProgramacion />} />
    </Routes>
    </>
  );
};

export default App;
